<div class="moduleCard">
  <div class="moduleTopContent">
    <img *ngIf="module.ModuleLogo != null" class="moduleLogo" [src]="module.ModuleLogo" alt="{{module.ModuleName}}Logo">
    <img *ngIf="module.ModuleImage != null" class="moduleImage" [src]="module.ModuleImage" alt="{{module.ModuleName}}Image">
    <img *ngIf="module.IsNew" class="newFlag" src="assets/images/New.png" alt="newFlag">
    <div class="moduleTitleContainer" *ngIf="module.ModuleImage == null">
      <div class="moduleTitleSpacer" *ngIf="module.Counter > 0"></div>
      <div class="moduleTitle w-100" *ngIf="module.ModuleImage == null">{{module.ModuleName}}</div>
      <div class="moduleTitleSpacer" *ngIf="module.Counter > 0">
        <div>{{ module.Counter }}&nbsp;</div><i class="bi bi-chat-dots-fill icon"></i>
      </div>
    </div>
  </div>
  <div class="moduleBottomContent justify-content-between">
    <div class="moduleText">{{module.ModuleDesc}}</div>
    <div class="moduleButton">{{module.ModuleButtonText}}</div>
  </div>
</div>
